import { useQuery } from "@apollo/client/react";
/** Default: plain Apollo `useQuery` (web and SSR). Third argument is ignored. */
export function bullrunUseQuery(query, options, _allowUnfocusedQueries) {
    return useQuery(query, options);
}
